"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergePriceObjects = mergePriceObjects;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

function mergePriceObjects(priceObjects) {
  var totalPrices = {
    monthly: {
      fullPrice: 0,
      calculatedPrice: 0,
      priceBreakdown: []
    },
    annually: {
      fullPrice: 0,
      calculatedPrice: 0,
      priceBreakdown: []
    },
    oneTimeFee: {
      fullPrice: 0,
      calculatedPrice: 0,
      priceBreakdown: []
    }
  };
  priceObjects.forEach(function (priceObject) {
    ['monthly', 'annually', 'oneTimeFee'].forEach(function (section) {
      totalPrices[section].fullPrice = totalPrices[section].fullPrice + priceObject[section].fullPrice;
      totalPrices[section].calculatedPrice = totalPrices[section].calculatedPrice + priceObject[section].calculatedPrice;
      totalPrices[section].priceBreakdown = [].concat((0, _toConsumableArray2.default)(totalPrices[section].priceBreakdown), (0, _toConsumableArray2.default)(priceObject[section].priceBreakdown));
    });
  });
  return totalPrices;
}